import {
  ACTIVE_STATUS_ACTIVE,
  ACTIVE_STATUS_INACTIVE,
  USER_FILTER_ALL,
  USER_FILTER_EMPTY,
} from "./teamUsersTable";

function normalizeBackendFilterValue(value) {
  if (value == null || value === USER_FILTER_ALL) return undefined;
  if (value === USER_FILTER_EMPTY) return "";
  return value;
}

function mapActiveStatusFilter(value) {
  if (value === ACTIVE_STATUS_ACTIVE) return true;
  if (value === ACTIVE_STATUS_INACTIVE) return false;
  return undefined;
}

/**
 * Canonical FE -> BE contract for Team / Users tables.
 * The backend is expected to accept these query params alongside pagination,
 * search and sort:
 * - title
 * - is_active
 * - role
 * - portal_access
 * - vqq_contact
 * - assessment_contact
 */
export function buildBackendUserFilterParams(filters = {}) {
  const title = normalizeBackendFilterValue(filters?.title);
  const isActive = mapActiveStatusFilter(filters?.activeStatus);
  const role = normalizeBackendFilterValue(filters?.role);
  const portalAccess = normalizeBackendFilterValue(filters?.portalAccess);
  const vqqContact = normalizeBackendFilterValue(filters?.vqqContact);
  const assessmentContact = normalizeBackendFilterValue(filters?.assessmentContact);

  return {
    ...(title !== undefined ? { title } : {}),
    ...(isActive !== undefined ? { is_active: isActive } : {}),
    ...(role !== undefined ? { role } : {}),
    ...(portalAccess !== undefined ? { portal_access: portalAccess } : {}),
    ...(vqqContact !== undefined ? { vqq_contact: vqqContact } : {}),
    ...(assessmentContact !== undefined
      ? { assessment_contact: assessmentContact }
      : {}),
  };
}

export async function fetchAllPagesFromPaginatedEndpoint(fetchPage) {
  const firstPage = await fetchPage(1);
  const totalPages = Math.max(1, firstPage?.total_pages ?? 1);

  if (totalPages === 1) {
    return {
      ...firstPage,
      items: firstPage?.items ?? [],
      total_items: firstPage?.total_items ?? (firstPage?.items?.length ?? 0),
      total_pages: totalPages,
    };
  }

  const remainingPages = await Promise.all(
    Array.from({ length: totalPages - 1 }, (_, index) => fetchPage(index + 2))
  );
  const items = [firstPage, ...remainingPages].flatMap((page) => page?.items ?? []);

  return {
    ...firstPage,
    items,
    total_items: firstPage?.total_items ?? items.length,
    total_pages: totalPages,
  };
}
